(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ac-art-supply-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wrappers = document.querySelectorAll('.ac-art-supply-collection__newsletter');
    if (!wrappers.length) return;
    const CONTACT_FORM_SCROLL_DURATION = 2500;

    const easeInOutCubic = (t) => (t < 0.5 ? 4 * t * t * t : 1 - ((-2 * t + 2) ** 3) / 2);
    const smoothScrollTo = (targetY, duration = 1000) => {
      const startY = window.scrollY;
      const maxY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      const clampedTargetY = Math.max(0, Math.min(targetY, maxY));
      const distance = clampedTargetY - startY;
      if (Math.abs(distance) < 2) return;

      let startTime = null;
      const step = (currentTime) => {
        if (startTime === null) startTime = currentTime;
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const eased = easeInOutCubic(progress);
        window.scrollTo(0, startY + distance * eased);
        if (progress < 1) requestAnimationFrame(step);
      };

      requestAnimationFrame(step);
    };

    const scrollToContactForm = () => {
      const contactForm = document.querySelector('#contact_form, #contactform');
      if (!(contactForm instanceof HTMLElement)) return false;

      // CSS-first approach: respects scroll-margin-top on the target.
      contactForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return true;
    };

    const url = new URL(window.location.href);
    const isPosted = url.searchParams.get('customer_posted') === 'true';
    const isContactHash = url.hash === '#contact_form' || url.hash === '#contactform';
    if (isPosted && isContactHash) {
      // Let native hash jump happen first, then re-apply CSS-based scroll.
      window.setTimeout(() => {
        scrollToContactForm();
      }, 120);
      // Mobile browsers can reflow after initial jump (address bar collapse),
      // so run one more pass to keep the final anchored offset stable.
      window.setTimeout(() => {
        scrollToContactForm();
      }, 420);
    }

    wrappers.forEach((wrapper) => {
      const statusElement = wrapper.querySelector('[data-newsletter-status]');
      const status = statusElement?.dataset?.newsletterStatus || 'idle';
      if (status === 'success') {
        wrapper.classList.add('is-submitted');
      }
      if (status !== 'success' && status !== 'error') return;

      requestAnimationFrame(() => {
        if (scrollToContactForm()) return;
        const rect = wrapper.getBoundingClientRect();
        const targetY = window.scrollY + rect.top - (window.innerHeight / 2 - rect.height / 2);
        smoothScrollTo(targetY, CONTACT_FORM_SCROLL_DURATION);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ac-menu-minimal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mqMobile = window.matchMedia('(max-width: 749px)');

    const setNavOpen = (root, open) => {
      root.classList.toggle('is-nav-open', open);
      document.body.classList.toggle('ac-menu-nav-open', open);
      document.querySelectorAll('[data-ac-menu-logo]').forEach((logo) => {
        logo.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    };

    const bind = (root) => {
      if (!root || root.dataset.acMenuNavBound === 'true') return;
      root.dataset.acMenuNavBound = 'true';

      const panel = root.querySelector('[data-ac-menu-panel]');
      if (!panel) return;
      const panelInner = root.querySelector('.ac-menu-minimal__panel-inner');
      const logo = document.querySelector('[data-ac-menu-logo]');

      if (logo) {
        logo.addEventListener('click', (e) => {
          if (!mqMobile.matches) return;
          const isOpen = root.classList.contains('is-nav-open');
          if (!isOpen) {
            e.preventDefault();
            setNavOpen(root, true);
          }
        });
      }

      document.addEventListener('click', (e) => {
        if (!mqMobile.matches || !root.classList.contains('is-nav-open')) return;
        if (root.contains(e.target)) return;
        if (logo && logo.contains(e.target)) return;
        setNavOpen(root, false);
      });

      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        if (root.classList.contains('is-nav-open')) setNavOpen(root, false);
      });

      mqMobile.addEventListener('change', () => {
        if (!mqMobile.matches) setNavOpen(root, false);
      });

      const desktopMq = window.matchMedia('(min-width: 750px)');
      const scrollThreshold = 70;
      const getScrollTop = () =>
        document.body?.scrollTop || document.documentElement?.scrollTop || window.scrollY || 0;
      let lastScrollY = getScrollTop();
      const onScroll = () => {
        const currentScrollY = getScrollTop();
        if (!desktopMq.matches) {
          root.classList.remove('is-scrolled');
          document.body.classList.remove('ac-menu-is-scrolled');
          document.body.classList.remove('ac-menu-scroll-up');
          lastScrollY = currentScrollY;
          return;
        }
        const isScrolled = currentScrollY > scrollThreshold;
        const isScrollingUp = currentScrollY < lastScrollY;

        root.classList.toggle('is-scrolled', isScrolled);
        document.body.classList.toggle('ac-menu-is-scrolled', isScrolled);
        document.body.classList.toggle('ac-menu-scroll-up', isScrolled && isScrollingUp);

        if (!isScrolled) {
          document.body.classList.remove('ac-menu-scroll-up');
        }
        lastScrollY = currentScrollY;
      };
      onScroll();
      const scrollTarget = document.body || window;
      scrollTarget.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('scroll', onScroll, { passive: true });
      desktopMq.addEventListener('change', onScroll);

      panel.querySelectorAll('a').forEach((a) => {
        a.addEventListener('click', () => {
          if (mqMobile.matches) setNavOpen(root, false);
        });
      });

      // Close when tapping anywhere inside the open panel (except interactive elements).
      if (panelInner) {
        panelInner.addEventListener('click', (e) => {
          if (!mqMobile.matches || !root.classList.contains('is-nav-open')) return;
          const target = e.target;
          if (!(target instanceof Element)) return;

          const interactiveSelector = 'a, button, summary, input, select, textarea, label, [role="button"], [role="link"]';
          if (target.closest(interactiveSelector)) return;

          setNavOpen(root, false);
        });
      }

      // Bag label count + keep custom cart drawer in sync after cart changes.
      document.addEventListener('cart:update', (event) => {
        const detail = event?.detail;
        const resource = detail?.resource;
        const data = detail?.data;

        let itemCount = null;
        if (resource && typeof resource.item_count === 'number') {
          itemCount = resource.item_count;
        } else if (data && typeof data.itemCount === 'number') {
          itemCount = data.itemCount;
        }

        if (itemCount !== null) {
          document.querySelectorAll('[data-ac-menu-bag-count]').forEach((el) => {
            el.textContent = `[${itemCount}]`;
          });
        }

        const sections = data?.sections;
        if (!sections || typeof sections !== 'object') return;

        const cartItemsComponent = root.querySelector('cart-items-component[data-section-id]');
        if (!cartItemsComponent) return;

        const sectionId = cartItemsComponent.getAttribute('data-section-id');
        if (!sectionId) return;

        const sectionHtml = sections[sectionId];
        if (!sectionHtml) return;

        const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const newCartItemsComponent = parsed.querySelector(`cart-items-component[data-section-id="${sectionId}"]`);
        if (!newCartItemsComponent) return;

        cartItemsComponent.replaceWith(newCartItemsComponent);
      });

      document.querySelectorAll('[data-ac-cart-open]').forEach((trigger) => {
        if (trigger.dataset.acCartBound === 'true') return;
        trigger.dataset.acCartBound = 'true';
        trigger.addEventListener('click', () => {
          const drawer = root.querySelector('cart-drawer-component') || document.querySelector('cart-drawer-component.ac-menu-minimal__cart-drawer');
          if (!drawer) return;
          if (typeof drawer.open === 'function') return drawer.open();
          customElements.whenDefined('cart-drawer-component').then(() => drawer.open?.());
        });
      });
    };

    const initAll = () => {
      document.querySelectorAll('[data-ac-menu-root]').forEach(bind);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (e) => {
      const el = e.target;
      if (!(el instanceof HTMLElement)) return;
      const root = el.matches('[data-ac-menu-root]') ? el : el.querySelector('[data-ac-menu-root]');
      if (root) bind(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ac-newsletter-signup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wrappers = document.querySelectorAll('.ac-newsletter-signup');
    if (!wrappers.length) return;

    const STORAGE_KEY = 'ac_newsletter_signup_snooze_until';
    const TWO_WEEKS_MS = 14 * 24 * 60 * 60 * 1000;
    const ART_SUPPLIES_PATH_FRAGMENT = '/collections/art-supplies';
    const ART_SUPPLIES_SCROLL_OFFSET = 300;
    const ART_SUPPLIES_SCROLL_DURATION = 2800;

    const now = () => Date.now();

    const getSnoozeUntil = () => {
      try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        const parsed = raw ? Number(raw) : 0;
        return Number.isFinite(parsed) ? parsed : 0;
      } catch {
        return 0;
      }
    };

    const setSnoozeUntil = (until) => {
      try {
        window.localStorage.setItem(STORAGE_KEY, String(until));
      } catch {
        // ignore storage failures (private mode, blocked storage, etc)
      }
    };

    const snoozeUntil = getSnoozeUntil();
    const isSnoozed = snoozeUntil && snoozeUntil > now();

    const easeInOutCubic = (t) => (t < 0.5 ? 4 * t * t * t : 1 - ((-2 * t + 2) ** 3) / 2);
    const smoothScrollTo = (targetY, duration = 1800) => {
      const startY = window.scrollY;
      const distance = targetY - startY;
      const maxY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      const clampedTargetY = Math.max(0, Math.min(targetY, maxY));
      const clampedDistance = clampedTargetY - startY;

      if (Math.abs(clampedDistance) < 2) return;

      let startTime = null;
      const step = (currentTime) => {
        if (startTime === null) startTime = currentTime;
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const eased = easeInOutCubic(progress);
        window.scrollTo(0, startY + clampedDistance * eased);

        if (progress < 1) {
          requestAnimationFrame(step);
        }
      };

      requestAnimationFrame(step);
    };

    const scrollNewsletterToCenter = (wrapper) => {
      if (!wrapper) return;
      const rect = wrapper.getBoundingClientRect();
      const targetY = window.scrollY + rect.top - (window.innerHeight / 2 - rect.height / 2);
      smoothScrollTo(targetY, 2500);
    };

    const scrollContactFormWithOffset = () => {
      const form = document.querySelector('#contact_form');
      if (!(form instanceof HTMLElement)) return false;

      const rect = form.getBoundingClientRect();
      const targetY = window.scrollY + rect.top - ART_SUPPLIES_SCROLL_OFFSET;
      smoothScrollTo(targetY, ART_SUPPLIES_SCROLL_DURATION);
      return true;
    };

    wrappers.forEach((wrapper) => {
      const closeButton = wrapper.querySelector('.ac-newsletter-signup__close');
      const fieldWrap = wrapper.querySelector('.ac-newsletter-signup__field-wrap');
      const input = wrapper.querySelector('.ac-newsletter-signup__input');
      const subtext = wrapper.querySelector('.ac-newsletter-signup__subtext');
      const submitButton = wrapper.querySelector('.ac-newsletter-signup__button');
      const statusElement = wrapper.querySelector('[data-newsletter-status]');
      const status = statusElement?.dataset?.newsletterStatus || 'idle';
      const shouldShow = !isSnoozed || status === 'success' || status === 'error';

      if (!shouldShow) return;

      wrapper.classList.add('is-visible');

      if (status === 'success' || status === 'error') {
        requestAnimationFrame(() => {
          const isArtSuppliesPage = window.location.pathname.includes(ART_SUPPLIES_PATH_FRAGMENT);
          if (isArtSuppliesPage && scrollContactFormWithOffset()) return;
          scrollNewsletterToCenter(wrapper);
        });
      }

      // Mark as "seen" when it is actually shown.
      setSnoozeUntil(now() + TWO_WEEKS_MS);

      if (input && input.disabled) {
        subtext?.classList.add('hidden');
        submitButton?.classList.add('hidden');
      }

      if (status === 'success') {
        // Keep it suppressed after successful signup.
        setSnoozeUntil(now() + TWO_WEEKS_MS);
      }

      if (fieldWrap && input) {
        const updateButtonState = () => {
          if (input.value.trim().length > 0) {
            fieldWrap.classList.add('has-value');
          } else {
            fieldWrap.classList.remove('has-value');
          }
        };

        updateButtonState();
        input.addEventListener('input', updateButtonState);
      }

      if (closeButton) {
        closeButton.addEventListener('click', () => {
          setSnoozeUntil(now() + TWO_WEEKS_MS);
          wrapper.classList.remove('is-visible');
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ac-simple-image-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wrappers = document.querySelectorAll('.ac-simple-image-text');
    if (!wrappers.length) return;

    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
    const collapseDistance = 30;
    const updateLineScale = () => {
      const progress = clamp(window.scrollY / collapseDistance, 0, 1);
      const scale = 1 - progress;
      wrappers.forEach((wrapper) => {
        wrapper.style.setProperty('--ac-simple-line-scale', `${scale}`);
      });
    };

    let rafId = null;
    const requestLineScaleUpdate = () => {
      if (rafId !== null) return;
      rafId = window.requestAnimationFrame(() => {
        updateLineScale();
        rafId = null;
      });
    };

    updateLineScale();
    window.addEventListener('scroll', requestLineScaleUpdate, { passive: true });
    window.addEventListener('resize', requestLineScaleUpdate);

    wrappers.forEach((wrapper) => {
      const typeTargets = wrapper.querySelectorAll('.js-typewriter');

      typeTargets.forEach((target, index) => {
        const original = target.textContent || '';
        const text = original.replace(/\s+/g, ' ').trim();
        if (!text.length) return;

        target.textContent = '';
        const textNode = document.createTextNode('');
        target.appendChild(textNode);

        let i = 0;
        const baseDelay = 6;
        const startDelay = 30 + index * 55;

        const getNextDelay = (char) => {
          let next = baseDelay + Math.floor(Math.random() * 55);

          if (char === ',' || char === ';' || char === ':') {
            next += 50;
          } else if (char === '.' || char === '!' || char === '?') {
            next += 85;
          } else if (char === ' ') {
            if (Math.random() < 0.2) next += 35;
          } else if (Math.random() < 0.07) {
            next += 60;
          }

          return next;
        };

        window.setTimeout(() => {
          const typeNext = () => {
            i += 1;
            textNode.textContent = text.slice(0, i);

            if (i >= text.length) {
              return;
            }

            const currentChar = text.charAt(i - 1);
            window.setTimeout(typeNext, getNextDelay(currentChar));
          };

          typeNext();
        }, startDelay);
      });

      const scrollLink = wrapper.querySelector('[data-scroll-to-collection="true"]');
      if (!scrollLink) return;

      scrollLink.addEventListener('click', (event) => {
        event.preventDefault();
        const target = document.querySelector('.ac-collection-product-list');

        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }

        window.scrollTo({
          top: window.innerHeight,
          behavior: 'smooth'
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ac-text-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.ac-text-page__content[data-h1-classes][data-h5-classes]');
    if (!sections.length) return;

    sections.forEach((content) => {
      const h1Classes = (content.dataset.h1Classes || '').trim();
      const h5Classes = (content.dataset.h5Classes || '').trim();
      if (!h1Classes && !h5Classes) return;

      if (h1Classes) {
        content.querySelectorAll('h1').forEach((heading) => {
          heading.classList.add(...h1Classes.split(/\s+/));
        });
      }

      if (h5Classes) {
        content.querySelectorAll('h5').forEach((heading) => {
          heading.classList.add(...h5Classes.split(/\s+/));
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
